import { statusToDocumentUploadMap } from "../../../constants/statusToDocMap/docUploadMap";
import { DocumentsStoreedInLocalStorage } from "../../../data-model/docsStorageInLocalStorage";
import {
  JCodeDetails,
  MedicalPaOrder,
} from "../../../data-model/medicalPaOrdersModel";
import { DocumentType } from "../../../enums/documentTypes";
import { LocalStorageKeys } from "../../../enums/localStorageKeys";
import { setItemInLocalStorage } from "../../../utils/localStorageHelper";
import { getAllJCodes } from "./existingDocsToLs";

// TypeScript interfaces for the CPT codes data structure
export interface JCodeObject {
  jCode: string;
  isDocPresent: { [key: string]: boolean };
  identifier: string;
  drugs: string;
}

// interface StatusToJCodesMap {
//   [status: string]: JCodeObject[];
// }

export const saveJCodeDocsToLocalStorage = (
  singleMedicalPaOrder: MedicalPaOrder,
) => {
  try {
    if (!singleMedicalPaOrder?.auth_on_file?.auth_entries) {
      return;
    }
    const documentsBasedOnType: any = Object.values(DocumentType).reduce(
      (acc, docType) => {
        acc[docType] = [];
        return acc;
      },
      {} as Record<DocumentType, DocumentsStoreedInLocalStorage[]>,
    );

    const allJCodes = getAllJCodes(singleMedicalPaOrder);
    allJCodes?.forEach((jCode) => {
      return prepareJCodeDocsForLS(jCode, documentsBasedOnType);
    });

    setItemInLocalStorage(
      `${LocalStorageKeys.JCode_Docs}_${singleMedicalPaOrder?.id}`,
      documentsBasedOnType,
    );
  } catch (error) {
    console.error("Error saving CPT codes to local storage:", error);
  }
};

const prepareJCodeDocsForLS = (
  jCodes: JCodeDetails,
  documentsBasedOnType: any,
) => {
  const getAllDocForAnAuthStatus =
    statusToDocumentUploadMap[jCodes?.auth_status || ""]?.documents || [];

  const jCodeDocs = jCodes?.documents || [];

  getAllDocForAnAuthStatus.forEach((doc: any) => {
    const isDocPresent = jCodeDocs.some(
      (jCodeDoc: any) =>
        jCodeDoc.doc_type === doc.doc_type &&
        jCodeDoc?.doc_path !== "" &&
        jCodeDoc?.doc_path !== null,
    );

    documentsBasedOnType[doc.doc_type] = [
      ...(documentsBasedOnType[doc.doc_type] || []),
      {
        isDocPresent: isDocPresent,
        docType: doc.doc_type,
        docPath:
          jCodeDocs.find((jCodeDoc: any) => jCodeDoc.doc_type === doc.doc_type)
            ?.doc_path || "",
        jcodeIdentifier: jCodes?.id || "",
        jcodeDescription: jCodes?.description || "",
        lastUpdatedAt:
          jCodeDocs.find((jCodeDoc: any) => jCodeDoc.doc_type === doc.doc_type)
            ?.doc_upload_date || "",
      } as DocumentsStoreedInLocalStorage,
    ];
  });

  return documentsBasedOnType;
};
